import { useEffect, useRef } from 'react';
import { useCountdown } from '../../../hooks/useCountdown';

/**
 * Counts down from `seconds` while `running` and calls `onEnd` exactly once when it reaches
 * zero. Nothing fires while `running` is false, so a stopped countdown never ends.
 */
export function useCountdownEnd(
  seconds: number,
  running: boolean,
  onEnd?: () => void
): number {
  const { remaining, done } = useCountdown(seconds, running);
  const fired = useRef(false);
  const onEndRef = useRef(onEnd);
  onEndRef.current = onEnd;

  useEffect(() => {
    if (!running || !done || fired.current) return;
    fired.current = true;
    onEndRef.current?.();
  }, [running, done]);

  return remaining;
}
